export enum TrafficTypeEnum {
  Low = "low",
  Peak = "peek",
  Normal = "normal",
}

export const getTrafficTypeTranslationKey = (
  traffic: TrafficTypeEnum | string | undefined,
): string => {
  switch (traffic) {
    case TrafficTypeEnum.Low:
      return "selectListLabel.low";
    case TrafficTypeEnum.Peak:
      return "selectListLabel.peak";
    default:
      return "selectListLabel.normal";
  }
};
